module.exports = __webpack_public_path__ + "media/images/page/sorry-tx-d62784bfb34a63f96e919a6edf7f88ca.png";